import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/design-from-html.css'
import './styles/global.scss'
import { toast, toastErr, toastOk } from '@/utils/toast'

Vue.config.productionTip = false
Vue.prototype.$toast = toast
Vue.prototype.$toastOk = toastOk
Vue.prototype.$toastErr = toastErr

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
